<script setup>
import DefaultModalBase from "../DefaultModalBase.vue";
import {useModalStore} from "../../../store/modal.js";
import {useTicketStore} from "../../../store/tickets.js";
import {computed, ref} from "vue";

const ticketStore = useTicketStore()
const modalStore = useModalStore()

const loading = ref(false)
const error = ref(null)
const is_complete = ref(false)

const ticketIds = computed(() => modalStore.props.ticket_ids ?? [])
const ticketCount = computed(() => ticketIds.value.length)

const heading = computed(() =>
    is_complete.value
        ? `${ticketCount.value} ticket(s) completed.`
        : `Are you sure you want to close ${ticketCount.value} ticket(s)?`
)

const completeTickets = async () => {
    loading.value = true
    error.value = null

    try {
        await ticketStore.bulkCompleteTickets(ticketIds.value)
        await ticketStore.refreshTickets()
        is_complete.value = true
    } catch (e) {
        error.value = e.response?.data?.message ?? 'Could not complete the tickets.'
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <DefaultModalBase :heading :error icon="check-all" :loading>

        <div class="kayako-reminder">
            <strong>Don't forget Kayako.</strong>
            <p>Completing these tickets here does not close them in Kayako. Please also close the tickets there.</p>
        </div>

        <div class="complete-ticket-actions">
            <brand-button @click="completeTickets()" v-if="!is_complete">Yes, mark as complete</brand-button>
            <brand-button variant="secondary" @click="modalStore.close()">{{ !is_complete ? "Nevermind" : "Done" }}</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.kayako-reminder {
    margin-bottom: 2rem;
    padding: 2rem;
    border-radius: 1.6rem;

    strong {
        color: #FFFFFF;
        @include font(1.4, 1.4, black);
    }

    p {
        margin: .8rem 0;
        @include font(1.3, 1.6, book);
    }
}

.complete-ticket-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
